export default __webpack_public_path__ + "static/media/print_logo.81bd2521.png";